import { MutationTuple, useMutation } from '@apollo/client';
import { RejectMilestoneInput, RejectMilestonePayload } from '@bechtel/types';
import { REJECT_MILESTONE } from '@bechtel/client-gql';

export function useRejectMilestone(
  onActionCompleted?: () => void
): //@ts-ignore type changed in @apollo/client
MutationTuple<{ rejectMilestone: RejectMilestonePayload }, { input: RejectMilestoneInput }> {
  const response = useMutation<{ rejectMilestone: RejectMilestonePayload }, { input: RejectMilestoneInput }>(
    REJECT_MILESTONE,
    {
      notifyOnNetworkStatusChange: true,
      onCompleted: () => {
        if (onActionCompleted) onActionCompleted();
      },
    }
  );
  return response;
}
